import React, { useCallback, useEffect, useMemo, useState } from "react";

const CountDown = ({ sailing_date }) => {
  const targetDate = useMemo(() => new Date(sailing_date), [sailing_date]);
  const calculateTimeLeft = useCallback(() => {
    const difference = targetDate.getTime() - new Date().getTime();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    return timeLeft;
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, calculateTimeLeft]);

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-4xl mb-4 text-white text-center font font-extrabold font-brandon">
        GET READY TO SET SAIL
      </h1>
      <div className="flex space-x-4 text-center">
        <div className="bg-mv-darkblue w-20 md:w-32 flex-shrink-1 h-auto text-white rounded-lg shadow-lg">
          <div className="text-6xl font-bold p-1 md:p-4">{timeLeft.days}</div>
          <div className="mt-2 bg-[#FFDF5D] font-semibold text-mv-darkblue text-lg">
            Days
          </div>
        </div>
        <div className="bg-mv-darkblue w-20 md:w-32 flex-shrink-1  h-auto text-white  rounded-lg shadow-lg">
          <div className="text-6xl font-bold p-1 md:p-4">{timeLeft.hours}</div>
          <div className="mt-2 bg-[#FFDF5D] font-semibold text-mv-darkblue  text-lg">
            Hours
          </div>
        </div>
        <div className="bg-mv-darkblue w-20 md:w-32 flex-shrink-1  h-auto text-white rounded-lg shadow-lg">
          <div className="text-6xl font-bold p-1 md:p-4 ">
            {timeLeft.minutes}
          </div>
          <div className="mt-2 bg-[#FFDF5D] font-semibold text-mv-darkblue  text-lg">
            Minutes
          </div>
        </div>
        <div className="bg-mv-darkblue w-20 md:w-32 flex-shrink-1  h-auto text-white rounded-lg shadow-lg">
          <div className="text-6xl p-1 md:p-4 font-bold">
            {timeLeft.seconds}
          </div>
          <div className="mt-2 bg-[#FFDF5D] font-semibold text-mv-darkblue  text-lg">
            Seconds
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountDown;
